export const resourceTypes = [
    'database',
    'storage',
    'redis',
    'lambda-api',
    'lambda-trigger',
    'api-gateway',
    'service',
    'cluster',
    'task-def',
    'ecr-repo',
    'vpc',
    'sg',
    'role',
    'load-balancer',
    'domain-firewall',
    'hosted-zone',
    'ssl-certificate',
    'cdk-stack',
    'secret',
    'ssm-param',
    'email-identity',
    'private-subnet',
    'public-subnet',
    's3',
    'log-group',
    'container',
    'isolated-subnet',
    'lb',
    'task-role',
    'execution-role',
    'xray',
    'auto-scaling',
    'dns-record',
    'lambda-fn',
    'cloudfront',
    'bastion',
    'sqs',
    'eventbridge-rule',
    'alarm',
    'schedule-group',
];
// Max LENGTH of the generated physical NAME per resource type, set to the
// binding AWS service quota for the service that resourceType maps to. Only
// types whose `getId().name` is used directly as a length-constrained physical
// name are listed; omitted types have no tight limit (the CloudFormation
// logical-id 255-char cap still applies to the `id`). `getId` throws when a
// generated name exceeds its limit — a name AWS would otherwise reject (or
// silently truncate, causing cross-env/clone collisions). Sources: AWS quotas.
export const resourceNameMaxLength = {
    'load-balancer': 32, // ALB/NLB name (the tightest common limit)
    lb: 32,
    redis: 40, // ElastiCache replication group id
    database: 63, // RDS DB instance identifier
    s3: 63, // S3 bucket (DNS-compatible)
    storage: 63, // treated as an S3-like bucket
    role: 64, // IAM role name
    'task-role': 64,
    'execution-role': 64,
    'lambda-fn': 64, // Lambda function name
    'lambda-api': 64,
    'lambda-trigger': 64,
    'cdk-stack': 128, // CloudFormation stack name
    service: 255, // ECS service
    cluster: 255, // ECS cluster
    sg: 255, // EC2 security group name
    'ecr-repo': 256, // ECR repository
    'eventbridge-rule': 64, // EventBridge rule name
    'schedule-group': 64, // EventBridge Scheduler group name
    sqs: 80, // SQS queue name
    alarm: 255, // CloudWatch alarm name
};
export const ssEnvironments = ['prod', 'staging', 'cameron', 'nate'];
export const ssApps = [
    'us-east-1-resources',
    'bootstrap-environment',
    'express-server',
    'remix-server',
    'remix-client',
    'postgres',
    'redis',
    'express',
];
/**
 * Our naming convention for resources is as follows:
 * env -> app(optional) -> purpose(optional) => resourceType
 * @description Get the name of a resource based on the props
 * @param props.resourceType The type of resource. Does not match amazon resource names
 * @param props.env is the environment the resource is in
 * @param props.appName is the app the resource is for (or global)
 * @param props.purpose is the purpose of the resource
 * @example
 * 'prod-redis-cache'
 * 'prod-postgres-database'
 * 'prod-vpc'
 * 'prod-express-server-service'
 * 'prod-express-server-container'
 * 'prod-express-server-cluster'
 */
export const getResourceName = (props) => {
    // @ts-expect-error
    if (props.env === 'old')
        return 'dev-event-registration-software';
    const { resourceType, env, appName, purpose } = props;
    if (appName && purpose)
        return `${env}-${appName}-${purpose}-${resourceType}`;
    if (appName)
        return `${env}-${appName}-${resourceType}`;
    if (purpose)
        return `${env}-${purpose}-${resourceType}`;
    return `${env}-${resourceType}`;
};
//# sourceMappingURL=aws-helpers.js.map